import debug from "debug";
import { newrelic } from "@jti/fe-clients";
class ErrorClient {
    logger;
    errorLogger;
    constructor() {
        this.logger = debug("product-details");
        this.errorLogger = this.logger.extend("error");
    }
    reportError(message) {
        this.errorLogger(message);
        console.error(message);
        newrelic.noticeError(new Error(message));
    }
}
export const errorClient = new ErrorClient();
//# sourceMappingURL=ErrorClient.js.map